import { render, staticRenderFns } from "./CentroCostos.vue?vue&type=template&id=0b0e1a3c&scoped=true"
import script from "./CentroCostos.vue?vue&type=script&lang=js"
export * from "./CentroCostos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0e1a3c",
  null
  
)

export default component.exports